import { DTOStartupViewDataset, DTOStartupDetailsViewDataset } from "components/types";

export const PLANS = {
    start: "start",
    plus: "plus",
    premium: "premium",
    salesPlus: "salesPlus"
}

export const PLANS_value = [
    { "value": "start", "label": "Start" },
    { "value": "plus", "label": "Plus" },
    { "value": "premium", "label": "Premium" },
    { "value": "sales", "label": "Sales" }
]

export const phone_regex = /^(\((00|\+)39\)|(00|\+)39)?(38[890]|34[6-90]|36[680]|33[3-90]|32[89])\d{7}$/gm;
export const website_regex = /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z0-9\u00a1-\uffff][a-z0-9\u00a1-\uffff_-]{0,62})?[a-z0-9\u00a1-\uffff]\.)+(?:[a-z\u00a1-\uffff]{2,}\.?))(?::\d{2,5})?(?:[/?#]\S*)?$/i
export const sdi_regex = /^[a-zA-Z0-9]{7}$/;
export const code_regex = /^[a-zA-Z0-9]{8}$/;
export const vat_regex = /^[0-9]{11}$/;
export const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const codiceFiscale_regex = /^[A-Za-z]{6}[0-9]{2}[A-Za-z]{1}[0-9]{2}[A-Za-z]{1}[0-9]{3}[A-Za-z]{1}$/
export const NOT_PERMITTED_VALUES = ["@", "www", ".it", ".com", ".io", "http", "url"]

export const link_terms = "https://www.innovationmatch.io/terms-and-conditions-it/"
export const link_privacy = "https://www.innovationmatch.io/privacy/"

export const MAX_FILE_SIZE:number = 15728640; //15MB
export const SUPPORTED_FORMATS =  ["image/jpg", "image/jpeg", "image/gif", "image/png"]
export const SUPPORTED_FORMATS_extensions =  ".jpeg, .jpg, .gif, .png"

export const Login_type = {
    startup: 1 ,
    corporate: 2,
    guest:3
}

export const PAGE_SIZE = {
    matchList: 6,
    matchListMobile: 4
}

 export const placeholderDataset: DTOStartupViewDataset[] = [
    { month: "jan", views: null },
    { month: "feb", views: null },
    { month: "mar", views: null },
    { month: "apr", views: null },
    { month: "may", views: null },
    { month: "jun", views: null },
    { month: "jul", views: null },
    { month: "aug", views: null },
    { month: "sep", views: null },
    { month: "oct", views: null },
    { month: "nov", views: null },
    { month: "dec", views: 0 },
  ];
 export const detailsPlaceholderViewDataset: DTOStartupDetailsViewDataset[] = [
     { label: "Human Resources", value: "0%" },
     { label: "Information Technology", value: "0%" },
    { label: "Innovation", value: "0%" },
    { label: "Marketing", value: "0%" },
    { label: "Other", value: "0%" },
  ];
